import React from 'react';
import { View, Text } from 'react-native';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const ConfirmSearchUser = () => {
    return (
        <>
            
            <HeaderDefault title={<FormattedMessage id='confirmSearchUser.headerBuscar'/>} />

            <View style={styles.container}>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='confirmSearchUser.txtValorTransferencia'/></Text>
                    <Text><FormattedMessage id='confirmSearchUser.txtValorBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='confirmSearchUser.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='confirmSearchUser.txtNome'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='confirmSearchUser.txtEmail'/></Text>
                    <Text><FormattedMessage id='confirmSearchUser.txtEnderecoEmail'/></Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='confirmSearchUser.btnContinuar'/>} titlePage={<FormattedMessage id='confirmSearchUser.btnConfirmaTransferencia'/>} />
        </>
    );
}

export default ConfirmSearchUser;